module.exports = __webpack_public_path__ + "static/media/16UNODC2.8dde5ad7.jpg";